function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dead"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512,256c0,141.38-114.62,256-256,256S0,397.38,0,256,114.61,0,256,0,512,114.62,512,256",
  fill: "#ffd764"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96,244.81a10.24,10.24,0,0,1-7.24-17.48L192.25,123.9a10.24,10.24,0,1,1,14.48,14.48L103.29,241.81a10.2,10.2,0,0,1-7.24,3Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.49,244.82a10.21,10.21,0,0,1-7.24-3L88.81,138.38a10.24,10.24,0,1,1,14.48-14.48L206.73,227.34a10.24,10.24,0,0,1-7.24,17.48Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.53,244.81a10.24,10.24,0,0,1-7.24-17.48L408.73,123.9a10.24,10.24,0,1,1,14.48,14.48L319.77,241.81a10.2,10.2,0,0,1-7.24,3Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M416,244.82a10.21,10.21,0,0,1-7.24-3L305.29,138.38a10.24,10.24,0,1,1,14.48-14.48L423.21,227.34A10.24,10.24,0,0,1,416,244.82Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M257,319.24V430.08c0,27.16,28.7,49.4,63.72,49.4h5.68c35,0,63.72-22.24,63.72-49.4V319.24Z",
  fill: "#fa645a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M323.55,428.28A10.23,10.23,0,0,1,313.31,418V331a10.24,10.24,0,0,1,20.48,0v87a10.23,10.23,0,0,1-10.24,10.24Z",
  fill: "#ae453e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.09,337.92H121.91a10.24,10.24,0,0,1,0-20.48H390.09a10.24,10.24,0,0,1,0,20.48Z",
  fill: "#4a4a4a"
}));

function SvgLose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dead") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLose);
export default __webpack_public_path__ + "static/media/lose.971a7f9d.svg";
export { ForwardRef as ReactComponent };